export default "__VITE_ASSET__BWywYkDu__"